import { useState } from 'react';

const useConstructor = (callBack: () => unknown) => {
  const [hasBeenCalled, setHasBeenCalled] = useState(false);
  if (hasBeenCalled) return;
  callBack();
  setHasBeenCalled(true);
};

export { useConstructor };
